// Estimated order margin from the lines whose cost is known (DT-1617). A line with no cost is
// excluded from BOTH sides: counting its revenue against only the known lines' cost inflated the
// estimate (4.58 uncosted + 14.17 at cost 4.43 showed 76.4% instead of 69%). `costedGross` is the
// costed lines' share of `gross`; the order's net (after the order-level discount, ex tax) is
// apportioned to them pro rata. Returns nulls when no line has a known cost or no costed revenue.
export function estimateMargin({ gross, net, costedGross, totalCost, costKnownLines }) {
  if (!(costKnownLines > 0) || !(gross > 0) || !(costedGross > 0)) {
    return { costedNet: null, marginAmount: null, marginPct: null };
  }
  const costedNet = net * (costedGross / gross);
  const marginAmount = costedNet - totalCost;
  const marginPct = costedNet > 0 ? (marginAmount / costedNet) * 100 : null;
  return { costedNet, marginAmount, marginPct };
}
